/* models/transforms/transform */ function _(require, module, exports) {
    var tslib_1 = require(426) /* tslib */;
    var model_1 = require(62) /* ../../model */;
    var Transform = /** @class */ (function (_super) {
        tslib_1.__extends(Transform, _super);
        function Transform(attrs) {
            return _super.call(this, attrs) || this;
        }
        Transform.__name__ = "Transform";
        return Transform;
    }(model_1.Model));
    exports.Transform = Transform;
}
